import util from "@/utils";
import api from "@/lib/api";

const Tracker = {
  // 上报接口
  async reportData(buryPointName, extend = {}) {
    const data = {
      buryPointName: buryPointName,
      extend: JSON.stringify(util.objectFilter(extend)),
      marsCid: util.getMarsCid(),
      appName: "fenxiao_h5"
    };
    api.reportData(data);
  },

  // 页面埋点
  page(buryPointName, extend = {}) {
    this.reportData(buryPointName, extend);
  },

  // 行为埋点
  action(buryPointName, extend = {}) {
    if (!extend.pageName) {
      extend.pageName = this.getCurrentPageName();
    }
    this.reportData(buryPointName, extend);
  }
};

export default Tracker;



// WEBPACK FOOTER //
// ./src/utils/tracker.js